import { ClassType, EntityType } from '@frontend/common';
import { StatusBadge } from '@frontend/components/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { Spinner } from '@frontend/elements';
import { ChangeClient } from '@frontend/sync/api';
import { ChangeStatusSelect } from '@frontend/sync/select';
import { Change, ChangeStatus, ChangeType } from '@frontend/sync/types';

import IotDataModal from './iot-data-modal/iot-data-modal.component';
import useIoTSeedOverview from './iot-seed-overview.controller';

const IoTSeedOverview = () => {
    const viewProps = useIoTSeedOverview();
    if (!viewProps.api || !viewProps.currentAccount || !viewProps.iot || !viewProps.iotIdentifier) {
        return <Spinner />;
    }
    return (
        <ReactiveObjectList<Change>
            fetch={(arg) => ChangeClient.fetchServiceChanges(viewProps.api!, { ...arg, iot_identifier: viewProps.iotIdentifier, status: viewProps.status })}
            dispatch={viewProps.dispatch}
            type={EntityType.CHANGE}
            id={viewProps.listId}
            useStaticListId
            label={viewProps.iot.name}
            onSelectElement={(o) => viewProps.openModal(viewProps.IOT_DATA_MODAL_ID, () => <IotDataModal data={o.data} />)}
            columns={{
                columns: ['entity_id', 'entity_type', 'type', 'status', 'creation_timestamp'],
                entityColumnOverwrite: new Map([['entity_id', 'entity_type']]),
                customCells: new Map([
                    [
                        'status',
                        (o) => (
                            <td>
                                <StatusBadge<ChangeStatus>
                                    value={o.row.original.status}
                                    colorMap={
                                        new Map([
                                            [[ChangeStatus.PENDING], ClassType.WARNING],
                                            [[ChangeStatus.FAILED], ClassType.DANGER],
                                            [[ChangeStatus.SUCCEEDED], ClassType.SUCCESS]
                                        ])
                                    }
                                    textSize='xs'
                                />
                            </td>
                        )
                    ],
                    [
                        'type',
                        (o) => (
                            <td>
                                <StatusBadge<ChangeType>
                                    value={o.row.original.type}
                                    colorMap={
                                        new Map([
                                            [[ChangeType.CREATE], ClassType.SUCCESS],
                                            [[ChangeType.DELETE], ClassType.DANGER],
                                            [[ChangeType.UPDATE], ClassType.WARNING],
                                            [[ChangeType.EVENT, ChangeType.SEED, ChangeType.REVERT], ClassType.INFO]
                                        ])
                                    }
                                    textSize='xs'
                                />
                            </td>
                        )
                    ]
                ])
            }}
            showCount
            customHeaderComponent={
                <div className='min-w-fit'>
                    <ChangeStatusSelect
                        value={viewProps.status}
                        onSelect={(v) => viewProps.setStatus(v ? v.value : null)}
                        isClearable
                    />
                </div>
            }
        />
    );
};

export default IoTSeedOverview;
